
import { Component, Prop, Vue } from 'vue-property-decorator'
import { LocaleMessageWithParams } from '@/commons/types'

@Component
export default class InputWithLabel extends Vue {
    @Prop() value!: string | null
    @Prop() setter!: (value: unknown) => void
    @Prop({ default: '' }) labelTranslationKey!: string
    @Prop() requirements!: Array<LocaleMessageWithParams> | undefined
    @Prop({ default: '' }) placeholderTranslationKey!: string
    @Prop({ default: 'off' }) autocomplete!: string

    get inputValue (): string | null {
        return this.value
    }

    set inputValue (value) {
        this.setter(value)
    }

    handleBlur (event: Event) {
        this.$emit('blur', event)
    }
}
